import styled, { css } from 'styled-components'
import { themeColor, themeFontWeight } from 'LibNeo'

export const Item = styled.div<{ active?: boolean }>`
	padding: 8px 15px;
	margin: 0 12px 0 12px;

	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	border: 1px solid transparent;
	border-radius: 4px;

	&:hover {
		cursor: pointer;
		border-color: ${themeColor('emerald', 2)};
	}

	${({ active }) =>
		active &&
		css`
			background-color: ${themeColor('emerald', 1)};
			&:hover {
				border-color: ${themeColor('emerald', 1)};
			}
		`}
`

export const IconWrapper = styled.div`
	flex: 0 0 auto;
	margin-right: 10px;
	margin-top: 1px;
`
export const TextWrapper = styled.div`
	flex: 1 1 auto;
	font-weight: ${themeFontWeight('SBSansText', 'regular')};
	font-size: 12px;
	line-height: 20px;
`
export const Title = styled.div`
	color: ${themeColor('gray', 8)};
`

export const Description = styled.div`
	color: ${themeColor('gray', 5)};
`
